<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-alert
          border="top"
          colored-border
          type="warning"
          elevation="2"
        >
          <ul>
            <li>Los <strong>expedientes</strong> son <strong>carpeta públicas</strong> que pueden acceder las personas que están en su misma organización, se utiliza para agrupar flujos, ciclos o documentos.</li>
            <li>Las <strong>carpetas personales</strong> son <strong>privadas</strong> solo usted las puede ver y le sirve para ordernar de mejor forma sus documentos.</li>
          </ul>
        </v-alert>

        <v-alert
          v-if="!this.$store.state.user.crear_expedientes"
          border="top"
          colored-border
          type="error"
          elevation="2"
        >
          <ul>
            <li>Usted no tiene privilegio de crear expedientes</li>
          </ul>
        </v-alert>

      </v-col>

      <v-col cols="12" md="4">
        <!--<h1 class="headline mb-1">Crear expediente <small style="font-size: 12px">pública</small></h1> -->
        <v-card class="mb-1">
          <v-card-text>
            <v-form 
              ref="form" 
              v-model="valid" 
              lazy-validation>
              <v-text-field 
                v-model="nombre_carpeta" 
                label="Nombre" 
                :rules="[rules.required]" 
                prepend-icon="mdi-file-settings-outline" 
                id="inputEmail">
              </v-text-field>

              <v-select
                v-if="!$store.state.user.crear_expedientes"
                @change="tipoCarpeta"
                v-model="tipo_carpeta"
                :items="tipo_1"
                :item-text="tipo_1.text"
                :item-value="tipo_1.value"
                :rules="[rules.required]"
                prepend-icon="mdi-folder-outline" 
                label="Tipo de carpeta"
              ></v-select>

              <v-select
                v-if="$store.state.user.crear_expedientes"
                @change="tipoCarpeta"
                v-model="tipo_carpeta"
                :items="tipo_2"
                :item-text="tipo_2.text"
                :item-value="tipo_2.value"
                :rules="[rules.required]"
                prepend-icon="mdi-folder-outline" 
                label="Tipo de carpeta"
              ></v-select>

              <v-text-field 
                readonly
                v-if="tipo_carpeta =='personal' && !es_principal"
                v-model="padre_nombre"
                label="Padre" 
                :rules="[rules.required]" 
                prepend-icon="mdi-folder-account-outline" 
                id="inputEmail">
              </v-text-field>

              <v-checkbox 
                v-if="tipo_carpeta =='personal'"
                v-model="es_principal"
                label="Es principal">
              </v-checkbox>

              <v-treeview
                dense
                v-if="tipo_carpeta =='personal' && !es_principal"
                v-model="selection"
                :items="$store.state.user.menu_personal"
                :selection-type="selectionType"
                @input="verSeleccion"
                selectable
                return-object
              >
              <template v-slot:label="{item, open, selected}">
                  {{item.nombre}}
              </template>
              </v-treeview>
                            
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn 
            :loading="loading"
            :disabled="!valid" 
            color="primary"  
            id="login" 
            class="mr-4" @click="validate" >Guardar</v-btn>
          </v-card-actions>
        </v-card>

      </v-col>
    </v-row>
  </v-container>
</template>
<script>
    import axios from "axios";       
    export default {  
    data: function() {
      return {
        valid: false,
        nombre_carpeta: '',
        tipo_carpeta: '',
        padre_id: '',
        loading: false,
        padre_nombre: '',
        es_principal: false,
        tipo_1: [{'text': 'Personal', 'value': 'personal'}],
        tipo_2: [{'text': 'Personal', 'value': 'personal'}, {'text': 'Expediente', 'value': 'publica'}],
        justify: 'center',
        alignment: 'center',
        rules: {
          required: value => !!value || 'Requerido',
          min: v => v.length >= 8 || 'Minimo 8 caracteres',
          emailMatch: () => ('The email and password you entered don\'t match'),
        },
        selection: [],
        selectionType: 'independent',
        open: ['public'],
      };
    },
    computed: {
    },
    mounted() {
      console.log("expediente.crear1");
      $("#inputEmail").keyup(function(event) {
        if (event.keyCode === 13) {
          $("#login").click();
        }
      });
    },
    methods: {
      validate () {
        let _this0 = this;
        if (this.$refs.form.validate()) {
          this.loading = true;
          let padre_id = (this.tipo_carpeta == "personal" ? (this.es_principal ? null : Number(this.padre_id)) : null);
          let url = (this.tipo_carpeta == "personal" ? 'Carpeta/Crear' : 'Carpeta/CrearExpediente');
          let postcarpeta = axios.post(url, 
            { "nombre":this.nombre_carpeta, "carpeta_padre_id" : padre_id}, { 'headers': this.$store.state.user.headers }
          )
          return postcarpeta.then((callback) => 
          {
            if(callback.status == 201 || callback.status == 200)
            {
              this.$store.dispatch('MAIN_MENU', { 'roles': this.$store.state.user.roles })
              .then(({status}) => {
                this.padre_id= '';
                this.selection = [];
                this.$refs.form.reset();
              })
              .catch(errorMenu => {
                console.log("MAIN_MENU... error");
              });
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'black', text: 'Carpeta creada' });
            } 
            this.loading = false;
          }).catch((error) => {
            console.log(error.response);
            this.loading = false;
          });
        }
      },
      verSeleccion(){
        this.padre_id = "";
        this.padre_nombre = "";
        if(this.selection.length > 0) {
          this.padre_id = this.selection[0].id;
          this.padre_nombre = this.selection[0].nombre;
        }
      },
      tipoCarpeta(){
      }
    },
  };
</script>